import React, {Component} from 'react';
import {Button, Modal, Popconfirm, Tooltip} from "antd";
import SimpleFloatTool from "./simpleFloatTool";
import securityIcon from "../components/pluginsSpace/securityPlugin/security.png";
import BaseComponent from "../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import {message} from '../../resource/components/Mess'
import loadIcon from "./loading.gif";
import noneIcon from "./none.png";
import normalIcon from "./normal.png";
import changeIcon from "./change.png";
import warnIcon from "./warn.png";
import $ from "jquery";
import {base64Encode, isSelf, letterUUID} from "../../../utils";
import {systemBaseEvent} from "../../../base/baseEvent";
import {getInfoFromLocalStorage} from "../../../actions";

$.fn.outerHTML = function() {
    return $('<div />').append(this.eq(0).clone()).html();
};
$.fn.getLabelAttr = function() {
    let outerHTML = this.outerHTML();
    return outerHTML.replace(/<([^>]+)>.*/, "$1");
};
$.fn.myText = function () {
// .clone()    //复制元素
// .children() //获取所有子元素
// .remove()   //删除所有子元素
// .end()  //回到选择的元素
// .text();//获取文本值
    return this.clone().children().remove().end().text();
};

const CONTENT_SECURITY = `content-security="true"`;
const checkColor = 'rgba(254, 1, 1, 0.95)'
const btnStyle = {color:"#fff", cursor:"pointer", padding:"2px 10px", background:(()=>{
        return (window.sysConfig && window.sysConfig.getValueByKey("NewMenuBg", "#0050B3")) || "#0050B3";
    })(), borderRadius:5};
export const removeContentSecurity = (content)=>{
    if(!content)
        return "";
    let $Content = $(`<div>${content}</div>`);
    let maxCount = 10000;
    let currentCount = 0;
    while(true){
        currentCount++;
        let $ContentSecurity = $Content.find(`[${CONTENT_SECURITY}]:eq(0)`);
        if($ContentSecurity.length === 0 || currentCount > maxCount){
            break;
        }
        $ContentSecurity.after($ContentSecurity.html());
        $ContentSecurity.remove();
    }
    return $Content.html();
};
const sortLength = (data, attr)=>{//按照属性值长度排序
    if(data){
        data.sort((d1,d2)=>{
            let len1 = 0;
            if(d1 && d1[attr])len1 = d1[attr].length;
            let len2 = 0;
            if(d2 && d2[attr])len2 = d2[attr].length;
            return len2 - len1;
        })
    }
};
const sortIndex = (data)=>{//按照正文出现的顺序排序
    if(data){
        data.sort((d1,d2)=>{
            let len1 = d1.index;
            let len2 = d2.index;
            return len1 - len2;
        })
    }
};
const regexConvertContent = (word, showCounts, newContent, contentCall=()=>{}, labelAttrCall=()=>{}, completeCall=()=>{})=>{//使用正则转换敏感内容，未解决部分问题，比如：<a href="http://xxxx">test</a>导致test不会被标记
    let regex = new RegExp(word, "g");
    let bracketsCount = 0;//括号出现的次数
    word.replace(/\([^)]*\)/g, function(item){bracketsCount++;return item});
    let matchResult = newContent.match(regex, "g");
    if(!matchResult || matchResult.length < showCounts){//目的是为了找到已经被标记的敏感词，但是被标记隔断了，导致无法展示出来//说明需要展示的敏感词有的已经被打乱了，比如 内容本来是 你好呀，但是敏感词为你好，被另一个敏感词好标记了，导致你好这个敏感词无法被匹配到
        //需要找到无法匹配的项
        let matchResultLength = 0;
        if(matchResult){
            matchResultLength = matchResult.length;
        }
        let needHandleCount = showCounts - matchResultLength;
        let remarkName = letterUUID();
        let regexStr = `security_.{${remarkName.length}}`;
        let regex = new RegExp(regexStr, "g");
        let remarkNames = newContent.match(regex);
        for(let i = 0 ; remarkNames && i < remarkNames.length; i++){
            let remarkName = remarkNames[i];
            let $remark = $(newContent).find(`[name='${remarkName}']`);
            if($remark.length > 0){
                $remark = $remark.clone();
                $remark.html($remark.html().replace(regex, ""));//目的为了找到被打乱的敏感词，没有被打乱的替换掉，避免被多次处理
                if($remark.text().indexOf(word) !== -1){//说明被隔断的敏感词就在该标记中。这里没有继续深入处理，比如这个区域可能包含了好几个被隔断的敏感词，这里返回了最大的那个区域
                    contentCall(remarkName);
                    -- needHandleCount;
                }
            }
        }
    }

    newContent = newContent.replace(regex,  function(str){//有两个是避免正则字符串中有子函数，当然可能会有很多子函数，这里暂时只匹配两次
        let remarkName = letterUUID();
        let index = arguments[bracketsCount + 1];
        let isReplace = false;
        let startStr = `<span name="security_${remarkName}" ${CONTENT_SECURITY} onclick="var $=top.$;$(this).before(this.getInnerHTML());$(this).remove();return false;" style="background-color:${checkColor};cursor:pointer">`;
        let endStr = `</span>`;
        if(index - startStr.length < 0){//说明不可能被标记过，也说明是前几个字就出现了敏感词
            isReplace = true;
        }else {
            // let regexStr = `<span name="security_(.{${remarkName.length}})" onclick="var \\$=top\\.\\$;\\$\\(this\\)\\.before\\(this\\.getInnerHTML\\(\\)\\);\\$\\(this\\)\\.remove\\(\\);return false;" style="background-color:red;cursor:pointer">`;
            let regexStr = `<span name="security_(.{${remarkName.length}})"[^<>]+>$`;
            let regex = new RegExp(regexStr);
            // if(!regex.test(newContent.substring(0, index))){//正则匹配了以标记结束  内容过多时，会导致浏览器卡死
            if(!regex.test(newContent.substring(index - startStr.length, index))){
                isReplace = true;
            }else{
                //说明已经被标记过了
                remarkName = newContent.substring(index - startStr.length, index).replace(regex, "$1");
                contentCall("security_"+remarkName);
                return str;
            }
        }
        if(isReplace && index > 0){//看一下这个内容是否在标签属性中
            let beforeContent = newContent.substring(0, index);
            let leftLabelIndex = beforeContent.lastIndexOf("<");
            if(leftLabelIndex !== -1){
                let rightLabelIndex = beforeContent.lastIndexOf(">");
                if(leftLabelIndex > rightLabelIndex){
                    isReplace = false;
                }
            }
        }
        if(isReplace){
            contentCall("security_"+remarkName);
            return `${startStr}${str}${endStr}`;
        }
        labelAttrCall();

        return str;
    });
    completeCall(newContent);
};
/**
 * item 一条检测结果
 * words 当前编辑器html的词元
 * newContent 当前编辑器文本
 * contentCall 在正文中找到了敏感词，回调返回当前敏感词标记的id
 * labelAttrCall 当前敏感词标记在标签属性中，回调不需要传参
 * completeCall 当前检测结果寻找结束，回调返回新的词元
 * */
const regexConvertContent_new = (item, words, newContent, contentCall=()=>{}, labelAttrCall=()=>{}, completeCall=()=>{}) => {
    console.log('words_new',words)
    let word = item.word;
    let index = item.index;
    // 待检测敏感词拆为词元
    let checkWords = word.split('').map((item,index2)=>({
        word: item,
        index: index2 + index,
        isCheck: false
    }))
    let haveWord = checkWords.every(item=>words.some(item2=>item2.wordIndex===item.index&&item.word===item2.word));
    if(haveWord) { // 正文中找到了满足条件的敏感词
        let remarkName = letterUUID();
        let startStr = `<span name="security_${remarkName}" ${CONTENT_SECURITY} onclick="var $=top.$;$(this).before(this.getInnerHTML());$(this).remove();return false;" style="background-color:${checkColor}!important;cursor:pointer!important;">`;
        let endStr = `</span>`;
        let startIndex = words.findIndex(item=>item.wordIndex===index); // 找到当前这个词开始的位置
        let endIndex = words.findIndex(item=>item.wordIndex===index+checkWords.length-1); // 找到当前这个词结束的位置
        words.splice(startIndex, 0, {
            word: startStr,
            wordIndex: null,
            index:startIndex,
        });
        words.splice(endIndex+2, 0, {
            word: endStr,
            wordIndex: null,
            index:endIndex+2,
        });
        contentCall(`security_${remarkName}`)
    } else { // 未找到相同索引敏感词，此时敏感词可能存在标签内部
        labelAttrCall()
    }
};
const format = (item)=>{
    if(item){
        let type = "";
        switch (item.category) {
            case "SENSITIVE": type = "敏感词"; break;
            case "PERSON_SENSITIVE": type = "敏感人物"; break;
            case "WRONG_CHARACTER": type = "错别字"; break;
            case "PRIVACY_INFORMATION": type = "隐私信息"; break;
            case "OUTSIDE_CHAIN": type = "疑似外链"; break;
            case "MISINFORMATION": type = "误报词库"; break;
        }
        return <span>{type}：<span style={{color:"red"}}>{item.word}</span>，建议{item.correctWord ? `修改为：${item.correctWord}` : '删除'}</span>;
    }
    return "";
};
const defaultRender = (field, value, name, checkResult, contentPadding=15, editor, showFloatToolFun=()=>{})=>{
    let findResult = findMultipleObject(checkResult, "word", null, false);
    if(!findResult || findResult.length === 0){
        return <></>;
    }
    sortIndex(findResult);
    let data = [];
    for(let i = 0 ; i < findResult.length; i++){
        let item = findResult[i];
        data.push({
            left: format(item),
            right:""
        });
    }
    return <InformationSpace
        contentPadding={contentPadding}
        title={<table cellSpacing={0} cellPadding={0} border={0} width={"100%"}><tbody><tr>
            <td>{name}区域</td>
            <td width={60} align={"right"}><span style={btnStyle} onClick={()=>{editor.setFocus(field);showFloatToolFun()}}>定位</span></td></tr>
        </tbody></table>} data={data}/>
};
const getSplitRules = function () {
    let arr = '<[^>]+>|(&((g|l|quo)t|#39|nbsp|amp);)|[^<>]';
    try {
        arr = JSON.parse(window.sysConfigGetValueByKey('word.check.split.rules', JSON.stringify(arr)));
    } catch (e) {
        return new RegExp(arr, 'mg')
    }
    return new RegExp(arr, 'mg')
}
/**
 * 将HTML解析成单词列表
 * 例：<a> Hello World </a>  ---> ["<a>"," ", "Hello", " ", "World", " ", "</a>"]
 * @param  {String}         html
 * @return {Array<String>}
 * /<[^>]+>|[^<|>|\w]|\w+\b|\s+/mg
 */
let convertHtml2Words = function(html) {
    let wordIndex = 0;
    let words = [];
    if(!html?.length) return words
    html
        .match(getSplitRules())
        .forEach((item, index, arr) => words.push(
            {
                word: item,
                wordIndex: needIndex({item, arr, index, words}) ? wordIndex++ : null,
                index,
            }
        ));
    return words
};
// 当前节点是否占用索引
const needIndexLabel = function () {
    let arr = [
        "</p>", "<br>", "</dir>",
        "</h1>", "</h2>", "</h3>", "</h4>", "</h5>", "</h6>",
        "</table>", "</ul>", "</ol>", "</dl>",
        "</pre>", "</noframes>", "</menu>", "</iframe>"
    ];
    try {
        arr = JSON.parse(window.sysConfigGetValueByKey('word.check.need.index.label', JSON.stringify(arr)));
    } catch (e) {
        return arr
    }
    return arr
}
const unNeedIndexSpace = ({item,arr,index, words}) => {
    return false // cbd改版，半角空格单独算一个占位符
    // 当前节点不是半角空白符
    if(!/^\u0020$/.test(item)) {
        return false
    }
    // 当前节点和下一个节点都是半角空白符
    if(arr[index+1] && /^\u0020$/.test(arr[index+1])) {
        return true
    }
    let findTextNode = findFirstMatchFromIndex(words, index, (node)=>!/^<[^>]*>$/.test(node.word)&&node.wordIndex!==null); // 寻找上一个非标签节点
    let findLabelNode = findFirstMatchFromIndex(words, index, (node)=>needIndexLabel().includes(node.word)&&node.wordIndex!==null); // 寻找上一个需要索引的标签节点
    if(findTextNode>=0 && findLabelNode>=0) {
        return findTextNode<findLabelNode; // 当前节点在占位标签节点后
    } else {
        return findTextNode<0 && findLabelNode<0 // 当前节点前面什么都没有
    }
}
const needIndex = ({item,arr,index,words}) => {
    if(unNeedIndexSpace({item,arr,index, words})) { // 当前节点是不需要占位的空白符
        return false
    }
    if(!/^<[^>]*>$/.test(item)) { // 非标签直接返回
        return true
    }
    if (needIndexLabel().some(Item => Item === item)) { // 不是需要索引的标签直接返回
        return true
    }
    return false
    let findTextNode = findFirstMatchFromIndex(arr, index, (node)=>!/^<[^>]*>$/.test(node)); // 寻找上一个非标签节点
    let findLabelNode = findFirstMatchFromIndex(arr, index, (node)=>needIndexLabel().includes(node)); // 寻找上一个需要索引的标签节点
    if(findTextNode>=0 && findLabelNode>=0) {
        return findTextNode>findLabelNode; // 当前节点在非标签节点后
    } else {
        return findTextNode>=0 // 当前节点前面存在非标签节点
    }
}
const findFirstMatchFromIndex = (array, startIndex, matchCondition) => {
    for (let i = startIndex-1; i >= 0; i--) {
        const currentNode = array[i];
        if (matchCondition(currentNode)) {
            return i;
        }
    }
    return -1;
}
const checkList = [
    {
        field:"title",
        name:"标题",
        refresh:false,
        getContent:(editor)=>{
            let info = editor.getInformation(false);
            return info && info.title;
        },
        render:({refresh, checkResult}, contentPadding=15, editor, showFloatToolFun=()=>{})=>defaultRender("title", (()=>{let info = editor.getInformation(false);return info ? info.title : ""})(),"标题",checkResult, contentPadding, editor, showFloatToolFun)
    },
    {
        field:"summary",
        name:"摘要",
        refresh:false,
        getContent:(editor)=>{
            let info = editor.getInformation(false);
            return info && info.variableFields && info.variableFields.summary;
        },
        render:({refresh, checkResult}, contentPadding=15, editor, showFloatToolFun=()=>{})=>defaultRender("summary", (()=>{let info = editor.getInformation(false);return (info && info.variableFields) ? info.variableFields.summary : ""})(),"摘要",checkResult, contentPadding, editor, showFloatToolFun)
    },
    {
        field:"content",
        name:"正文",
        refresh:false,
        getContent:(editor)=>{
            return editor.getPlainTxt()
            let content = editor.getContent();
            return removeContentSecurity(content);
        },
        render:(self, contentPadding=15, editor, showFloatToolFun=()=>{})=>{
            let {refresh, checkResult} = self;
            let findResult = findMultipleObject(checkResult, "word", null, false);
            // sortLength(findResult, "word");
            sortIndex(findResult);
            let oldContent = editor.getContent();
            let newContent = refresh ? removeContentSecurity(oldContent) : oldContent;
            let data = self.data;
            let words = convertHtml2Words(newContent);
            if(self.refresh) {
                data = []
                findResult?.length && findResult.map(item => {
                    let count = findMultipleObject(checkResult, "word", item.word, false).length;
                    let successCall = false;
                    regexConvertContent_new(
                        item, words, newContent,
                        (_remarkName) => {
                            successCall = true;
                            let remarkName = _remarkName;
                            data.push({
                                left: format(item),
                                remarkName: _remarkName,
                                right: <span remark-name={_remarkName} onClick={ (e)=> {
                                    if (!remarkName) {
                                        message.error(`标记id为空，无法定位，敏感词：${item.word}！`);
                                    } else {
                                        let range = editor.selection.getRange();
                                        let node = $(editor.document).find(`[name='${remarkName}']`);
                                        if (node && node.length > 0) {
                                            node = node[0];
                                            range.setStartBefore(node);
                                            range.setEndAfter(node);
                                            range.select();
                                            setTimeout(() => showFloatToolFun());
                                            editor.reactScrollbar.scrollToBottom();
                                            $(editor.document).scrollTop(node.offsetTop);
                                        } else {
                                            message.error(`无法定位，该敏感词可能被拆解为更短的敏感词或已被忽略！`);
                                        }
                                    }
                                }} style={btnStyle}>定位</span>
                            })
                        },
                        () => {
                            successCall = true;
                            data.push({
                                left: format(item),
                                right: <span onClick={() => {
                                    if(typeof item.sentence === "string" && item.sentence?.length) {
                                        Modal.warning({
                                            title: '敏感词在html标签属性中',
                                            content: item.sentence,
                                        });
                                    } else {
                                        message.error(`敏感词存在于标签属性中，无法定位，请切换至源码进行手动查找！`);
                                    }
                                }} style={btnStyle}>定位</span>
                            })
                        },
                    );
                });
            } else {
                // 本次刷新时间比较上次刷新时间间隔大于3秒，则重新处理数据
                if(Date.now() - self.refreshtime > 3000) {
                    data = self.data.filter(item=>{
                        if(!item.remarkName) {
                            return true
                        }
                        let node = $(editor.document).find(`[name='${item.remarkName}']`);
                        if (node && node.length > 0) {
                            return true
                        }
                        return false
                    })
                }
            }
            self.data = data;
            if(self.refresh){
                console.log('words_over',words)
                let newContent = words.map(item=>item.word).join('');
                console.log('newContent',newContent)
                if(newContent!==oldContent ){
                    self.refreshtime = Date.now();
                    // setTimeout(()=>{//这里用异步是为了减少栈中更新状态的次数，去掉的话不影响功能，但会报警告错误。
                    editor.setContent(newContent);
                    // },0);
                }
            }
            self.refresh = false;//避免多次更新内容
            if(!findResult || findResult.length === 0){
                return <></>
            }
            return <InformationSpace contentPadding={contentPadding} title={"正文区域"} data={data}/>
        }
    },
    {
        field:"attach",
        name:"附件",
        refresh:false,
        getContent:(editor)=>{
            let info = editor.getInformation(false);
            if(!info){
                return null;
            }
            let attach = info.attach;
            return attach;
        },
        asyncNext:async (request, itemAttach)=>{
            return new Promise((resolve, reject) => {
                if(!itemAttach || !itemAttach.md5){
                    reject();
                }
                request({
                    url: "/cm-sites-analysis/analysis/getInfoByMd5",
                    body:{md5:itemAttach.md5},loading:false,
                    callBack:(data)=>{
                        let text = "";
                        if(data){
                            text += (data.coverInfo && data.coverInfo.fileName)?data.coverInfo.fileName:"";
                            text += (data.contentInfo && data.contentInfo.text)?data.contentInfo.text:""
                        }
                        resolve(text)
                    }
                })
            });
        },
        render:(self, contentPadding=15, editor, showFloatToolFun=()=>{})=>{
            let data = [];
            for(let i = 0 ; self.checkResult && i < self.checkResult.length; i++){
                let child = self.checkResult[i];
                let {name, md5, childCheckResult} = child;
                let findResult = findMultipleObject(childCheckResult, "word", null, false);
                sortIndex(findResult);
                if(findResult && findResult.length > 0){
                    data.push({
                        trStyle:{background: "#fff",border:"1px solid #e3e3e3",height:35},
                        left: name,
                        right:<Popconfirm placement="topLeft" title={"您确定要删除吗？"}
                                          onConfirm={()=>{
                                              editor.delAttachByMd5(md5);
                                              self.checkResult = self.checkResult.filter(_item=>_item!=child);
                                              showFloatToolFun();
                                          }}
                        ><span style={{...btnStyle, background:"red"}}>删除</span></Popconfirm>
                    })
                }
                findResult && findResult.map(item=>data.push({
                    trStyle:{background: "#fff",height:45},
                    left: format(item),
                    right:<></>
                }));
            }
            if(data.length === 0){
                return <></>;
            }
            return <InformationSpace titleStyle={{marginBottom:10}} contentPadding={contentPadding}
                                     title={<span style={{marginBottom:10}}>{self.name}区域</span>} data={data}/>
        }
    }
];
const clearCheckResult = (field)=>{
    checkList.map(item=>{
        if(field){
            if(item.field === field){
                item.checkResult = null;
            }
        }else{
            item.checkResult = null;
        }
    })
};
const setCheckResult = (field, checkResult)=>{
    for(let i = 0 ; i < checkList.length; i++){
        let item = checkList[i];
        if(item.field === field){
            item.checkResult = checkResult;
            return;
        }
    }
};

const findTypeCount = (object, attr, value)=>{
    let count = 0;
    if(object){
        if(object instanceof Array){
            object.map(item=>{
                count += findTypeCount(item, attr, value);
            });
        }else if(typeof object === "object"){
            for(let __attr in object){
                if(object[__attr] instanceof Array){
                    count += findTypeCount(object[__attr], attr, value);
                }else{
                    if(__attr === attr && object[attr] === value){
                        count ++;
                    }
                }
            }
        }
    }
    return count;
};
export const findObject = (object, attr, value)=>{
    if(object){
        if(object instanceof Array){
            for(let i = 0 ; i < object.length; i++){
                let item = object[i];
                let res = findObject(item, attr, value);
                if(res){
                    return res;
                }
            }
        }else if(typeof object === "object"){
            for(let __attr in object){
                if(object[__attr] instanceof Array){
                    let res = findObject(object[__attr], attr, value)
                    if(res){
                        return res;
                    }
                }else{
                    if(__attr === attr && object[attr] === value){
                        return object;
                    }
                }
            }
        }
    }
    return null;
};
const findMultipleObject = (object, attr, value, checkExists=true)=>{
    let result = [];
    let exists = (obj)=>{
        if(!checkExists){
            return false;
        }
        for(let i = 0 ; i < result.length; i++){
            let item = result[i];
            if(isSelf(item, obj, null, ["word","category"])){
                return true;
            }
        }
        return false;
    };
    let append = (objs) =>{
        for(let i = 0; i < objs.length; i++){
            let item = objs[i];
            if(!exists(item)){
                result.push(item);
            }
        }
    };
    if(object){
        if(object instanceof Array){
            for(let i = 0 ; i < object.length; i++){
                let item = object[i];
                let res = findMultipleObject(item, attr, value, checkExists);
                append(res);
            }
        }else if(typeof object === "object"){
            if(!value && object[attr]){
                result.push(object);
            }
            for(let __attr in object){
                if(object[__attr] instanceof Array){
                    let res = findMultipleObject(object[__attr], attr, value, checkExists);
                    append(res);
                }else{
                    if(value){
                        if(__attr === attr && object[attr] === value && !exists(object)){
                            result.push(object);
                        }
                    }
                }
            }
        }
    }
    return result;
};
const findAndRemove = (object, attr, value)=>{//这里里面的前提是数组里面只能是对象，不能数组套数组,对象里面不能套对象.
    let newObject = object;
    if(object){
        if(object instanceof Array){
            newObject = [];
            for(let i = 0 ; i < object.length; i++){
                let item = object[i];
                if(typeof item === "object"){
                    if(item[attr] !== value){
                        newObject.push(item);
                        for(let __attr in item){
                            if(item[__attr] instanceof Array){
                                item[__attr] = findAndRemove(item[__attr], attr, value);
                            }
                        }
                    }
                }
            }
        }else if(typeof object === "object"){
            if(object[attr] === value){
                return null;
            }
            for(let __attr in object){
                if(object[__attr] instanceof Array){
                    object[__attr] = findAndRemove(object[__attr], attr, value)
                }
            }
        }
    }
    return newObject;
};

const operation = {
    add:"add",
    update:"update",
};
class SecurityCheck extends BaseComponent {

    static defaultProps = {
        checkStatus: "none",
        dialogVisible: false,
        simpleFloatToolVisible: false
    };

    constructor(props) {
        super(props);
        //编辑器各个信息字段的监听方式与编辑器内容区域监听的方式不一样， editorInformationItemChange监听使用的系统自己封装的，内容区域监听是从编辑器自上而下方法调用实现的，不过systemBaseEvent方法是最优的。
        systemBaseEvent.registerBaseEvent("editorInformationItemChange", ({key, value})=>{
            this.listenInformationChange(key, value);
        });
        systemBaseEvent.registerBaseEvent("editorIdChange", ({editorId})=>{
            this.listenEditorIdChange(editorId);
        });
        systemBaseEvent.registerBaseEvent("editorAddData", ()=>{
            this.listenEditorDataOperation(operation.add);
        });
        systemBaseEvent.registerBaseEvent("editorUpdateData", ()=>{
            this.listenEditorDataOperation(operation.update);
        });
        systemBaseEvent.registerBaseEvent("editorAjaxShowDataUrlChange", (url)=>{
            this.listenEditorAjaxShowDataUrl(url);
        });
        systemBaseEvent.registerBaseEvent("editorDataChange", (data)=>{
            this.listenEditorData(data);
        });
        systemBaseEvent.registerBaseEvent("editorContentChange", (data)=>{
            this.listenContentChange(data);
        });
    }

    state = {
        checkStatus: this.props.checkStatus,
        checkField: "",
        dialogVisible: this.props.dialogVisible,
        simpleFloatToolVisible: this.props.simpleFloatToolVisible,
    };

    //获取浮动图标的位置，这里基于编辑器进行定位.
    getFloatIconPost(){
        let getLeft = ()=>{
            return $("#webbereditor").length > 0 ? parseInt($("#webbereditor")[0].offsetLeft) - 80 : 300;
        };
        let left = getLeft();
        setTimeout(()=>{
            let _left = getLeft();
            if(_left!=left){
                this.setState({});
            }
        },10);
        return {
            bottom : 60, left
        };
    }

    listenInformationChange(key, value){//监听编辑器信息字段变化
        if(["title", "summary", "upload"].indexOf(key) !== -1){
            this.setState({
                checkStatus : "change"
            })
        }
    }

    lastContent;
    listenContentChange(data){
        if(!data) return; // 不再使用传递下来的异步调用，而是使用监听器监听编辑器contentchange
        this.removeColorByInheritCheck(data);
        if(this.lastContent === data){
            return;
        }
        if(!this.state.dialogVisible){//如果安全检测的大框子打开的时候，用户肯定无法手动更改内容
            if(["none", "loading"].indexOf(this.state.checkStatus) === -1){
                this.setState({
                    checkStatus : "change"
                })
                // this.lastContent = this.props.editor.getContent();
            }else{
                this.setState({
                    checkStatus : "changed"
                })
            }
        }
    }

    removeColorByInheritCheck = (data) => {
        let body = $(this.props.editor.body);
        let checkSpan = body.find(`span[style*="background-color: ${checkColor}"]`).not(`[${CONTENT_SECURITY}]`);
        if (checkSpan.length > 0) {
            console.log('清空继承自敏感词检测的红色背景=====removeColorByInheritCheck')
            checkSpan.each(function () {
                this.style.backgroundColor = "";
            })
        }
    }

    getFloatIcon (count){
        switch (this.state.checkStatus) {
            case "change" : return changeIcon;
            case "over" : return count > 0 ? warnIcon : normalIcon;
            case "loading" : return loadIcon;
            default : return noneIcon;
        }
    }

    filterCheckItem = {//过滤不需要检测的项
        init:false,
        list:[],
        filter:(data)=>{
            this.filterCheckItem.list && this.filterCheckItem.list.map(item=>{
                data = findAndRemove(data, item.key, item.value);
            });
            return data;
        }
    };

    initFilterCheckItem = ()=>{
        if(!this.filterCheckItem.init){
            this.filterCheckItem.init = false;
            this.filterCheckItem.list = JSON.parse(this.sysConfigGetValueByKey("filter.check.item", `[{"key":"word","value":"[0-9]"}]`));
        }
    };

    checkAfterContinueExecFun;
    securityCheckKey;
    //同步检测
    asyncCheck = async ({checkAfterContinueExecFun, noDataShowInfo=false})=>{
        this.lastContent = this.props.editor.getContent();
        let key = this.securityCheckKey || this.editorId;
        if(!key || key === "0"){
            message.warning("请先暂存稿件");
            return new Promise((resolve, reject) => {});
        }
        this.securityCheckKey = key;
        this.checkAfterContinueExecFun = !checkAfterContinueExecFun ? null : ()=>{
            //去除内容区域内所有标记过的敏感词;
            let content = this.props.editor.getContent();
            let newContent = removeContentSecurity(content);
            checkAfterContinueExecFun(newContent);
        };
        if(this.state.checkStatus !== "loading"){
            this.initFilterCheckItem();
            clearCheckResult();
            this.setState({
                dialogVisible:false,
                checkField: "",
                checkStatus: "loading",
            });
            if(this.simpleFloatTool){
                this.simpleFloatTool.hide();
            }

            let contents = {};
            for(let i = 0 ; i < checkList.length; i++){
                let item = checkList[i];
                item.refresh = true;
                this.setState({
                    checkField: item.name
                });
                let str = item.getContent(this.props.editor);
                if(str){
                    if(str instanceof Array){//如果是数组
                        //就遍历执行下一步
                        let arr = str;
                        if(item.asyncNext){
                            for(let j = 0 ; j < arr.length; j++) {
                                let child = arr[j];
                                await item.asyncNext(this.request, child).then((data)=>{
                                    contents[`${item.field}_${j}`] = data;
                                });
                            }
                        }
                    }else{
                        contents[item.field] = str;
                    }
                }
            }
            await this.checkAjax(contents).then((data)=>{
                for(let i = 0 ; i < checkList.length; i++){
                    let item = checkList[i];

                    let str = item.getContent(this.props.editor);
                    if(str) {
                        if (str instanceof Array) {//如果是数组
                            //就遍历执行下一步
                            let arr = str;
                            if (item.asyncNext) {
                                item.checkResult = [];
                                for (let j = 0; j < arr.length; j++) {
                                    let child = arr[j];
                                    item.checkResult.push({...child, childCheckResult: data[2][`${item.field}_${j}`]});
                                }
                            }
                        }else{
                            item.checkResult = data[2][item.field];
                        }
                    }
                }
            });
        }
        let {allCount} = this.getStatistic();
        if(allCount === 0 && this.checkAfterContinueExecFun){
            this.setState({
                checkStatus: "over",
            });
            this.checkAfterContinueExecFun();
        }
        return new Promise((resolve, reject) => {
            if(allCount > 0 || noDataShowInfo){
                resolve();
                this.simpleFloatTool.hide();
                window.loading.hide();
                this.setState({
                    checkStatus: "over",
                },()=>{
                    setTimeout(()=>{
                        this.setState({dialogVisible:true},()=>{
                        });
                    },100);
                });
            }
        });
    };

    editorId;
    listenEditorIdChange(editorId){
        this.editorId = editorId;
    }
    dataOperation = operation.add;//数据是新增
    listenEditorDataOperation(operation){
        this.dataOperation = operation;
    }
    editorAjaxShowDataUrl;
    listenEditorAjaxShowDataUrl(url){
        this.editorAjaxShowDataUrl = url;
    }
    editorData;
    listenEditorData(data){
        this.editorData = data;
    }

    checkAjax = async (contents)=>{
        let editorId = this.editorId;
        let replaceItems = this.sysConfigGetValueByKey("security.check.content.replace", "vsb,small").split(",");
        for(let attr in contents){
            replaceItems.map(item=>{
                contents[attr] = contents[attr].replaceAll(item, "");
            });
            contents[attr] = base64Encode(contents[attr]);
        }

        let currentUser = getInfoFromLocalStorage("currentUser");
        let storyName = this.editorData.title;
        let info = this.props.editor.getInformation(false);
        if(info && info.title){
            storyName = info.title;
        }
        let metaInfo = {
            id : editorId,
            check_info_url: this.editorAjaxShowDataUrl + editorId,
            storyName,
            storyStatusName: this.editorData.statusName,
            mediaName: this.editorData.mediaName,
            createUserName: currentUser.name,
            deptName: currentUser.defaultInfo.dept.name
        };
        if(this.dataOperation === operation.add) {
            // 新增稿件
            metaInfo.createStoryUserName = currentUser.name;
            metaInfo.createStorydeptName = currentUser.defaultInfo.dept.name;
            metaInfo.createStoryMediaName= this.editorData.mediaName;
        } else {
            // 编辑稿件
            console.log("this.editorData========",this.editorData);
            // 注：目前网站稿件没有部门信息，所以没有部门id时不传部门信息（防止部门信息与其他位置冲突）
            // metaInfo.createStoryUserName = await this.getUserNameById(this.editorData.submitter);
            metaInfo.createStoryUserName = this.editorData.creatorName || this.editorData.submitterName;
            if(this.editorData.deptId) {
                metaInfo.createStorydeptName = await this.getDeptNameById(this.editorData.deptId);
            }
            if(this.editorData.mediaName) {
                metaInfo.createStoryMediaName= this.editorData.mediaName;
            }
        }

        return new Promise((resolve, reject) => {
            this.request({
                url : "/cm-sites-sys/contentCheck/check",
                body:{
                    key: editorId,
                    contents: contents,
                    data: metaInfo,
                    encryptType: "base64"
                },
                contentType: 'json',
                loading:false,
                method:"post",
                callBack:(data)=>{
                    resolve(data);
                }
            })
        });
    };

    getUserNameById = (id) => {
        return new Promise((resolve, reject) => {
            this.request({
                url : "/cm-sites-sys/user/getUserById",
                body:{id},
                loading:false,
                callBack:(data)=>{
                    resolve(data);
                }
            })
        });
    };

    getDeptNameById = (id) => {
        return new Promise((resolve, reject) => {
            this.request({
                url : "/cm-sites-sys/dept/getById",
                body:{id},
                loading:false,
                callBack:(data)=>{
                    if(data&&data.name) {
                        resolve(data.name);
                    }else {
                        resolve("");
                    }
                },
                errorCallBack: (e) => {
                    resolve("");
                }
            })
        });
    };

    show = ()=>{
        this.simpleFloatTool.show();
    };

    getStatistic = ()=>{
        let cloudPoliticalSensitiveCount = 0;
        let cloudPersonSensitiveCount = 0;
        let localPoliticalSensitiveCount = 0;
        let localPersonSensitiveCount = 0;
        let localPrivacyInformationCount = 0;
        let localOutsideChainCount = 0;

        let allCount = 0;
        let cloudCount = 0;
        let localCount = 0;
        for(let i = 0 ; i < checkList.length; i++){
            let item = checkList[i];
            let checkResult = item.checkResult;
            checkResult = this.filterCheckItem.filter(checkResult);

            let _local = findMultipleObject(checkResult, "sign", "local", false);
            let _cloud = findMultipleObject(checkResult, "sign", "cloud", false);

            let _cloudPoliticalSensitiveCount = findTypeCount(_cloud, "category", "SENSITIVE");//云端敏感词
            cloudPoliticalSensitiveCount += _cloudPoliticalSensitiveCount;
            let _cloudPersonSensitiveCount = findTypeCount(_cloud, "category", "PERSON_SENSITIVE");//云端敏感人物
            cloudPersonSensitiveCount += _cloudPersonSensitiveCount;

            let _localPoliticalSensitiveCount = findTypeCount(_local, "category", "SENSITIVE");//本地敏感词
            localPoliticalSensitiveCount += _localPoliticalSensitiveCount;
            let _localPersonSensitiveCount = findTypeCount(_local, "category", "PERSON_SENSITIVE");//本地敏感人物
            localPersonSensitiveCount += _localPersonSensitiveCount;
            let _localPrivacyInformationCount = findTypeCount(_local, "category", "PRIVACY_INFORMATION");//本地隐私信息
            localPrivacyInformationCount += _localPrivacyInformationCount;
            let _localOutsideChainCount = findTypeCount(_local, "category", "OUTSIDE_CHAIN");//本地外链
            localOutsideChainCount += _localOutsideChainCount;

            let _cloudCount = _cloudPoliticalSensitiveCount + _cloudPersonSensitiveCount;
            cloudCount += _cloudCount;
            let _localCount = _localPoliticalSensitiveCount + _localPersonSensitiveCount + _localPrivacyInformationCount;
            localCount += _localCount;
            let _allCount = _cloudCount + _localCount;
            allCount += _allCount;
        }
        allCount += localOutsideChainCount;
        return {allCount, localCount, cloudCount,
            cloudPoliticalSensitiveCount, cloudPersonSensitiveCount,
            localPoliticalSensitiveCount,localPersonSensitiveCount,localPrivacyInformationCount,localOutsideChainCount
        };
    };

    showFloatTool = ()=>{
        this.setState({dialogVisible:false});
        this.simpleFloatTool.show();
    };

    render() {
        let {allCount, localCount, cloudCount,
            cloudPoliticalSensitiveCount, cloudPersonSensitiveCount,
            localPoliticalSensitiveCount,localPersonSensitiveCount,localPrivacyInformationCount,localOutsideChainCount
        } = this.getStatistic();

        let blockStyle = {color:"#fff",backgroundColor:"red",padding:"2px 10px", borderRadius : 3,margin:"0 5px"};

        let content = <div>
            <LongStatisticsSpace data={[
                {render:()=><span style={{marginLeft:10}}>共检测到：敏感信息
                                <span style={{color:"red",fontSize:16,margin:"0 5px"}}>{cloudCount + localCount}</span>
                                    条
                        {/*（云端检测：<span style={{margin:"0 5px"}}>{cloudCount}</span>条、本地检测：<span style={{margin:"0 5px"}}>{localCount}</span>条）*/}
                                <span style={{marginLeft:30}}>疑似外链：<span style={{color:"blue",fontSize:16,margin:"0 5px"}}>{localOutsideChainCount}</span>条</span>
                            </span>},
                {render:()=><span style={{marginLeft:10}}>其中：
                                <span style={blockStyle}>敏感词<span style={{margin:"0 5px"}}>{cloudPoliticalSensitiveCount + localPoliticalSensitiveCount}</span></span>
                                <span style={blockStyle}>隐私信息<span style={{margin:"0 5px"}}>{localPrivacyInformationCount}</span></span>
                                <span style={blockStyle}>敏感人物<span style={{margin:"0 5px"}}>{localPersonSensitiveCount + cloudPersonSensitiveCount}</span></span>
                                <span style={blockStyle}>非法链接<span style={{margin:"0 5px"}}>0</span></span>{/*与其他地方保持一致加上了非法链接*/}
                        <span style={{...blockStyle, backgroundColor:"blue"}}>疑似外链<span style={{margin:"0 5px"}}>{localOutsideChainCount}</span></span>
                            </span>}
            ]} />
            {
                checkList.map((item, index)=>{
                    if(item.render && item.checkResult ){
                        return <span key={index}>{item.render(item,15, this.props.editor, ()=>this.showFloatTool())}</span>;
                    }
                })
            }
        </div>;
        return (
            <div>
                <Tooltip placement={"top"} title={(()=>{
                    switch (this.state.checkStatus) {
                        case "change" : return "发现编辑器内容变化，请重新检测";
                        case "loading" : return "检测中请稍后";
                        default : return "单击开始内容检测"
                    }
                })()}>
                    <table height={53}
                           onClick={()=>this.asyncCheck({noDataShowInfo:true})}
                           border={0} cellPadding={0} cellSpacing={0} width={51}
                           style={{cursor:"pointer", zIndex:998, position:"fixed", ...this.getFloatIconPost(),
                               background: `url(${this.getFloatIcon(allCount)}) no-repeat`}}><tbody><tr>
                        <td valign={"middle"} align={"center"} style={{color:"#fff", fontSize:18}}>
                            {this.state.checkStatus === "over" && allCount > 0 && (allCount > 99 ? "99+" : allCount)}
                        </td></tr></tbody>
                    </table></Tooltip>
                <Modal
                    title={"敏感信息检测"}
                    footer={null}
                    maskClosable={false}
                    width={380}
                    closable={false}
                    visible={this.state.checkStatus === "loading"}
                    closeIcon={false}
                ><img src={loadIcon} width={50} style={{marginRight:10}} />正在进行敏感信息检测，请稍后...</Modal>

                <Modal
                    title={"安全检测"}
                    footer={<div style={{textAlign:"center",height:25,marginTop:5}}>
                        <span onClick={()=>this.asyncCheck({checkAfterContinueExecFun:this.checkAfterContinueExecFun,noDataShowInfo:true})} style={{padding:"5px 15px",cursor:"pointer", border:"1px #e3e3e3 solid",borderRadius:5}}>再次检测</span>
                        <span onClick={()=>this.showFloatTool()} style={{padding:"5px 15px",cursor:"pointer", border:"1px #e3e3e3 solid",borderRadius:5,color:"#fff",background:this.themeBgColor, marginLeft:10}}>返回修改</span>
                        {this.checkAfterContinueExecFun && <span onClick={()=>{this.setState({dialogVisible:false});this.checkAfterContinueExecFun()}} style={{marginLeft:10, padding:"5px 15px",cursor:"pointer", border:"1px #e3e3e3 solid",borderRadius:5}}>全部忽略并继续</span>}
                    </div>}
                    width={800}
                    visible={this.state.dialogVisible}
                    bodyStyle={{padding:10}}
                    maskClosable={false}
                    onCancel={()=>{
                        this.showFloatTool();
                    }}
                >
                    <Scrollbars
                        autoHeightMax={480}
                        autoHeight={true}
                    >
                        <div style={{padding:"0 20px"}}>
                            {this.state.dialogVisible && content}
                        </div>
                    </Scrollbars>
                </Modal>
                <SimpleFloatTool
                    ref={(simpleFloatTool) => this.simpleFloatTool = simpleFloatTool}
                    visible={this.state.simpleFloatToolVisible}
                    width={270}
                    title={
                        <span style={{fontSize: 14, lineHeight: 3}}>
                            <img src={securityIcon} width={44} style={{margin: "0 -10px"}}/> <b>敏感信息检测结果</b>
                        </span>
                    }
                    footer={
                        <Button
                            type={"primary"}
                            size={"small"}
                            onClick={() => this.asyncCheck({noDataShowInfo: true})}
                        >再次检测</Button>
                    }
                    bottomAlign={"center"}
                >
                    <LongStatisticsSpace data={[
                        {
                            render: () => <span>共检测到<br/>敏感信息
                            <span style={{color: "red", margin: "0 5px"}}>{cloudCount + localCount}</span>
                                条
                                {/*（云端检测：<span style={{margin: "0 5px"}}>{cloudCount}</span>条、本地检测：<span*/}
                                {/*    style={{margin: "0 5px"}}>{localCount}</span>条）*/}
                                <br/>
                            <span>疑似外链：<span
                                style={{color: "blue", margin: "0 5px"}}>{localOutsideChainCount}</span>条</span>
                        </span>
                        }
                    ]}/>
                    {
                        checkList.map((item, index) => {
                            if (item.render && item.checkResult) {
                                return <span style={{maxWidth: 150}}
                                             key={index}>{item.render(item, 5, this.props.editor, () => this.showFloatTool())}</span>;
                            }
                        })
                    }
                </SimpleFloatTool>
            </div>
        );
    }
}


class LongStatisticsSpace extends Component{

    static defaultProps = {
        data: [],
        title: "",
    };


    render() {
        return (<div style={{marginTop:15}}>
            <div  style={{
                background: "rgba(245, 108, 108, 0.02)",
                border: "1px solid rgba(245, 108, 108, 0.1)",
                borderRadius: "5px",
                overflow: "hidden",
            }}>
                <table cellSpacing={0} cellPadding={5} border={0} width={"100%"}>
                    <tbody>
                    {
                        this.props.data && this.props.data.map((item, index) => {
                            return <tr height={34} key={index}>
                                <td width={"100%"}>{item.render && item.render()}</td>
                                <td></td>
                            </tr>
                        })
                    }
                    </tbody>
                </table>
            </div>
        </div>)
    }
}

/**
 * 统计区域
 */
class StatisticsSpace extends Component{

    static defaultProps = {
        data: [],
        title: "",
    };


    render() {
        return (<div style={{marginTop:15}}>
            {this.props.title && <div style={{lineHeight:3}}>{this.props.title}</div>}
            <div  style={{
                background: "rgba(245, 108, 108, 0.02)",
                border: "1px solid rgba(245, 108, 108, 0.1)",
                borderRadius: "5px",
                overflow: "hidden",
            }}>
                <table cellSpacing={0} cellPadding={5} border={0} width={"100%"}>
                    <tbody>
                    {
                        this.props.data && this.props.data.map((item, index) => {
                            if (index % 2 === 0) {
                                if ((index + 1) < this.props.data.length) {
                                    let next = this.props.data[index + 1];
                                    return <tr key={index}>
                                        {/*<td>{item.name}：<span style={{color:"red",fontSize:16}}>{item.remark}</span></td>*/}
                                        <td width={"50%"}>{item.render && item.render()}</td>
                                        <td width={"50%"}>{next.render && next.render()}</td>
                                    </tr>
                                } else {
                                    return <tr key={index}>
                                        <td width={"50%"}>{item.render && item.render()}</td>
                                        <td></td>
                                    </tr>
                                }
                            }
                        })
                    }
                    </tbody>
                </table>
            </div>
        </div>)
    }
}

class InformationSpace extends Component{

    static defaultProps = {
        data: [],
        title: "",
        titleStyle: {},
        contentPadding:15
    };

    render() {
        return <div style={{marginTop:15}}>
            <table cellSpacing={0} cellPadding={5} border={0} width={"100%"} style={{background:"#d9e3f1",...this.props.titleStyle}}><tbody>
            <tr><td height={30} colSpan={2} style={{padding:`0 ${this.props.contentPadding}px`}}>{this.props.title}</td></tr>
            </tbody></table>
            {this.props.data && this.props.data.length > 0 && <table cellSpacing={0} cellPadding={5} border={0} width={"100%"}><tbody>
            {this.props.data.map((item, index)=>{
                let style = item.trStyle?item.trStyle:{};
                return (
                    <tr style={{lineHeight:2,...style}} height={35} key={index}>
                        <td style={{padding:`0 ${this.props.contentPadding}px`,wordBreak: "break-all"}}>{item.left}</td>
                        {item.right ? <td style={{padding:`0 ${this.props.contentPadding}px`}} width={50 + this.props.contentPadding * 2} valign={"middle"} align={"right"}>{item.right}</td>:<td width={1}></td>}
                    </tr>)
            })}
            </tbody></table>}
        </div>
    }
}

export default SecurityCheck;